import { useRef, useState } from "react";
import { toast } from "sonner";
import { ArrowUp, ArrowDown, Trash2, Upload, Link2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, errMsg, imgUrl } from "@/lib/api";
import { Card } from "./BookingsTab";

export const PhotosTab = ({ prop, onSaved }) => {
  const [photos, setPhotos] = useState(() => [...(prop.photos || [])]);
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);
  const move = (i, dir) => {
    const a = [...photos];
    const j = i + dir;
    if (j < 0 || j >= a.length) return;
    [a[i], a[j]] = [a[j], a[i]];
    setPhotos(a);
  };
  const upload = async (files) => {
    setBusy(true);
    const added = [];
    for (const f of Array.from(files || [])) {
      const fd = new FormData();
      fd.append("file", f);
      try {
        const { data } = await api.post("/admin/upload", fd);
        added.push({ url: data.url, caption: "" });
      } catch (e) { toast.error(`${f.name}: ${errMsg(e)}`); }
    }
    setPhotos((p) => [...p, ...added]);
    setBusy(false);
    if (added.length) toast.success(`${added.length} foto(s) subida(s). Recuerda guardar.`);
  };
  const save = async () => {
    try {
      const { data } = await api.put(`/admin/properties/${prop.id}`, { photos });
      onSaved(data);
      toast.success("Fotos guardadas");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-6 space-y-6" data-testid="admin-photos">
      <Card className="flex flex-col gap-3 md:flex-row md:items-center">
        <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp" multiple hidden onChange={(e) => upload(e.target.files)} data-testid="photo-file-input" />
        <button data-testid="photo-upload-button" disabled={busy} onClick={() => fileRef.current?.click()} className="flex items-center justify-center gap-2 rounded-lg bg-[#2C2016] px-5 py-2.5 text-sm font-semibold text-white disabled:opacity-50"><Upload className="h-4 w-4" />{busy ? "Subiendo…" : "Subir fotos"}</button>
        <div className="flex flex-1 gap-2">
          <Input data-testid="photo-url-input" placeholder="…o pega la URL de una imagen" value={url} onChange={(e) => setUrl(e.target.value)} />
          <button data-testid="photo-add-url-button" onClick={() => { if (url) { setPhotos([...photos, { url, caption: "" }]); setUrl(""); } }} className="flex items-center gap-1 rounded-lg border border-[#2C2016]/20 px-4 text-sm"><Link2 className="h-4 w-4" />Añadir</button>
        </div>
        <button data-testid="photos-save-button" onClick={save} className="rounded-lg bg-[#B8532F] px-6 py-2.5 text-sm font-semibold text-white">Guardar orden y fotos</button>
      </Card>
      <p className="text-sm text-[#4A3525]">La primera foto es la portada (hero). Las 5 primeras forman la galería principal.</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {photos.map((p, i) => (
          <Card key={`${p.url}-${i}`} className="!p-3">
            <div className="relative aspect-[4/3] overflow-hidden rounded-xl bg-[#E8D8C3]">
              <img src={imgUrl(p.url)} alt="" className="h-full w-full object-cover" />
              <span className="absolute left-2 top-2 rounded-full bg-black/60 px-2 py-0.5 text-xs text-white">{i === 0 ? "Portada" : i + 1}</span>
            </div>
            <Input className="mt-2 h-9 text-xs" placeholder="Descripción" value={p.caption || ""} onChange={(e) => setPhotos(photos.map((x, j) => (j === i ? { ...x, caption: e.target.value } : x)))} />
            <div className="mt-2 flex justify-between">
              <div className="flex gap-1">
                <button onClick={() => move(i, -1)} className="rounded p-1.5 hover:bg-[#2C2016]/5" data-testid={`photo-up-${i}`}><ArrowUp className="h-4 w-4" /></button>
                <button onClick={() => move(i, 1)} className="rounded p-1.5 hover:bg-[#2C2016]/5" data-testid={`photo-down-${i}`}><ArrowDown className="h-4 w-4" /></button>
              </div>
              <button onClick={() => setPhotos(photos.filter((_, j) => j !== i))} className="rounded p-1.5 text-[#B8532F] hover:bg-[#B8532F]/10" data-testid={`photo-delete-${i}`}><Trash2 className="h-4 w-4" /></button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
